namespace RedBullMOBILE360.SMSCodes {
    export interface InformativeSmsRow {
        Id?: number;
        Code?: string;
        MessageEn?: string;
        MessageAr?: string;
    }

    export namespace InformativeSmsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'SMSCodes.InformativeSms';
        export const deletePermission = 'SMSCodes:InformativeSms';
        export const insertPermission = 'SMSCodes:InformativeSms';
        export const readPermission = 'SMSCodes:InformativeSms';
        export const updatePermission = 'SMSCodes:InformativeSms';

        export declare const enum Fields {
            Id = "Id",
            Code = "Code",
            MessageEn = "MessageEn",
            MessageAr = "MessageAr"
        }
    }
}
